<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <designated-form :info="info"></designated-form>
      </div>
    </div>
  </section>
</template>

<script>
import designatedForm from './Temp/designatedForm.vue'
export default {
  components: {
    'designated-form': designatedForm
  },
  data () {
    return {
      info: {
        attend_stores: [],
        give_coupons: [],
        strategy_data: {},
        info: {}
      }
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  },
  created () {
    // if (this.$route.name === 'upActivity') this.getActivity()
  },
  methods: {
    getActivity () {
      var self = this
      var url = 'activity/' + this.$route.params.activity_id + '/orderCouponComplete'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// CrDesignated.vue?1810fe36